import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SessionData, SessionService } from "@app/core/services/session.service";
import { isNotEmpty } from "@app/core/utils";
import dateFormat from "dateformat";
import { BehaviorSubject } from "rxjs";
@Component({
    selector: "app-distribution-policy-signature",
    templateUrl: "./distribution-policy-signature.component.html",
    styleUrls: ["./distribution-policy-signature.component.scss"],
    standalone: false,
})
export class DistributionPolicySignatureComponent implements OnInit {
    show: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    hasAllUserInfo: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    userName: BehaviorSubject<string> = new BehaviorSubject<string>("");
    name: BehaviorSubject<string> = new BehaviorSubject<string>("");
    date: BehaviorSubject<string> = new BehaviorSubject<string>("");

    constructor(private sessionService: SessionService, private route: ActivatedRoute) {}

    ngOnInit() {
        this.show.next(false);
        this.loading.next(true);

        const accountUid = this.route.snapshot.queryParams.accountUid;

        if (accountUid) {
            this.getAccountDataByUid(accountUid);
        } else {
            this.sessionService.sessionData.subscribe({
                next: (sessionData: SessionData) => {
                    this.show.next(false);
                    this.loading.next(true);

                    if (!sessionData || !sessionData.account) {
                        this.loading.next(false);
                        return;
                    }

                    this.getAccountDataByUid(sessionData.account.uid);
                },
                error: () => {
                    this.loading.next(false);
                },
            });
        }
    }

    getAccountDataByUid(accountUid: string) {
        this.loading.next(true);

        this.sessionService.getAccountData(accountUid).subscribe({
            next: (account) => {
                if (!account.settings["developer.distributionPolicy"]) {
                    this.show.next(false);
                } else {
                    this.name.next(account.settings["name"]);
                    this.userName.next(account.ownerUser["emailAddress"]);
                    this.date.next(
                        account["legalDocumentsModifiedTimestamps"]["developer.distributionPolicy"]
                            ? dateFormat(new Date(account["legalDocumentsModifiedTimestamps"]["developer.distributionPolicy"]), "yyyy-mm-dd")
                            : ""
                    );
                    this.hasAllUserInfo.next(isNotEmpty(this.userName.value) && isNotEmpty(this.name.value) && isNotEmpty(this.date.value));
                    this.show.next(this.hasAllUserInfo.value);
                }

                this.loading.next(false);
            },
            error: (error) => {
                this.show.next(false);
                this.loading.next(false);
            },
        });
    }
}
